<template>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex justify-between h-16">
      <div class="flex">
        <div class="flex-shrink-0 flex items-center">
          <div
            class="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-gradient-to-br from-primary-500 to-accent-red mr-3"
          >
            <span class="text-white font-bold text-lg font-display">P</span>
          </div>
          <h1 class="text-xl font-bold text-gradient font-display">pushx.pro</h1>
        </div>
        <nav class="hidden sm:ml-8 sm:flex sm:space-x-6">
          <router-link
            to="/dashboard"
            class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-all duration-200"
            :class="
              activeIndex === 'dashboard'
                ? 'border-primary-500 text-white'
                : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-600'
            "
          >
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
              ></path>
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 5a2 2 0 012-2h4a2 2 0 012 2v6H8V5z"
              ></path>
            </svg>
            Дашборд
          </router-link>
          <router-link
            to="/applications"
            class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-all duration-200"
            :class="
              activeIndex === 'applications'
                ? 'border-primary-500 text-white'
                : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-600'
            "
          >
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
              ></path>
            </svg>
            Приложения
          </router-link>
          <router-link
            to="/analytics"
            class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-all duration-200"
            :class="
              activeIndex === 'analytics'
                ? 'border-primary-500 text-white'
                : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-600'
            "
          >
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
            </svg>
            Аналитика
          </router-link>
          <router-link
            to="/sdk-documentation"
            class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-all duration-200"
            :class="
              activeIndex === 'sdkdocumentation'
                ? 'border-primary-500 text-white'
                : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-600'
            "
          >
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
              ></path>
            </svg>
            Документация
          </router-link>
          <router-link
            to="/debug-console"
            class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-all duration-200"
            :class="
              activeIndex === 'debugconsole'
                ? 'border-primary-500 text-white'
                : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-600'
            "
          >
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              ></path>
            </svg>
            Консоль
          </router-link>
          <router-link
            to="/referrals"
            class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-all duration-200"
            :class="
              activeIndex === 'referrals'
                ? 'border-primary-500 text-white'
                : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-600'
            "
          >
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
              ></path>
            </svg>
            Партнёрам
          </router-link>
          <router-link
            to="/profile"
            class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-all duration-200"
            :class="
              activeIndex === 'profile'
                ? 'border-primary-500 text-white'
                : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-600'
            "
          >
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              ></path>
            </svg>
            Профиль
          </router-link>
        </nav>
      </div>
      <div class="flex items-center space-x-4">
        <!-- User info -->
        
        <button
          @click="handleLogout"
          class="inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg text-gray-400 hover:text-white bg-gray-800/50 hover:bg-gray-800 border border-gray-700 hover:border-gray-600 transition-all duration-200"
        >
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            ></path>
          </svg>
          Выйти
        </button>
      </div>
    </div>
    
    <!-- Mobile menu button -->
    <div class="sm:hidden flex items-center py-2">
      <button
        @click="mobileMenuOpen = !mobileMenuOpen"
        class="inline-flex items-center justify-center p-2 rounded-lg text-gray-400 hover:text-white hover:bg-gray-800 transition-colors"
      >
        <svg v-if="!mobileMenuOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
        <svg v-else class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    
    <!-- Mobile menu -->
    <Transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="opacity-0 -translate-y-2"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-2"
    >
      <div v-if="mobileMenuOpen" class="sm:hidden pb-4">
        <nav class="flex flex-col space-y-1">
          <router-link
            to="/dashboard"
            @click="mobileMenuOpen = false"
            class="flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors"
            :class="activeIndex === 'dashboard' ? 'bg-primary-500/20 text-primary-500' : 'text-gray-400 hover:text-white hover:bg-gray-800'"
          >
            <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"></path>
            </svg>
            Дашборд
          </router-link>
          <router-link
            to="/applications"
            @click="mobileMenuOpen = false"
            class="flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors"
            :class="activeIndex === 'applications' ? 'bg-primary-500/20 text-primary-500' : 'text-gray-400 hover:text-white hover:bg-gray-800'"
          >
            <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6z"></path>
            </svg>
            Приложения
          </router-link>
          <router-link
            to="/analytics"
            @click="mobileMenuOpen = false"
            class="flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors"
            :class="activeIndex === 'analytics' ? 'bg-primary-500/20 text-primary-500' : 'text-gray-400 hover:text-white hover:bg-gray-800'"
          >
            <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
            </svg>
            Аналитика
          </router-link>
          <router-link
            to="/sdk-documentation"
            @click="mobileMenuOpen = false"
            class="flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors"
            :class="activeIndex === 'sdkdocumentation' ? 'bg-primary-500/20 text-primary-500' : 'text-gray-400 hover:text-white hover:bg-gray-800'"
          >
            <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253"></path>
            </svg>
            Документация
          </router-link>
          <router-link
            to="/debug-console"
            @click="mobileMenuOpen = false"
            class="flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors"
            :class="activeIndex === 'debugconsole' ? 'bg-primary-500/20 text-primary-500' : 'text-gray-400 hover:text-white hover:bg-gray-800'"
          >
            <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
            Консоль
          </router-link>
          <router-link
            to="/referrals"
            @click="mobileMenuOpen = false"
            class="flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors"
            :class="activeIndex === 'referrals' ? 'bg-primary-500/20 text-primary-500' : 'text-gray-400 hover:text-white hover:bg-gray-800'"
          >
            <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"></path>
            </svg>
            Партнёрам
          </router-link>
          <router-link
            to="/profile"
            @click="mobileMenuOpen = false"
            class="flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors"
            :class="activeIndex === 'profile' ? 'bg-primary-500/20 text-primary-500' : 'text-gray-400 hover:text-white hover:bg-gray-800'"
          >
            <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
            </svg>
            Профиль
          </router-link>
        </nav>
      </div>
    </Transition>
  </div>
</template>

<script>
import { useAuthStore } from '../stores/auth';

export default {
  name: 'NavBar',
  setup() {
    const authStore = useAuthStore();

    return {
      authStore,
    };
  },
  data() {
    return {
      activeIndex: this.$route.name?.toLowerCase() || 'dashboard',
      mobileMenuOpen: false,
    };
  },
  watch: {
    $route(to) {
      this.activeIndex = to.name?.toLowerCase() || 'dashboard';
      this.mobileMenuOpen = false;
    },
  },
  methods: {
    async handleLogout() {
      await this.authStore.logout();
      this.$router.push('/login');
    },
  },
};
</script>
